import React from "react";
import "./AP.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import aboutimg from "../../Media/FotoAbout.webp";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6282332091818&text=Halo%20Anthony,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Citra%20Garden%20Bintaro%20(About%20Us)%20https://citra-garden-bintaro.id/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="aboutproduk" id="about">
      <div className="containerabout">
        <h1>Citra Garden Bintaro</h1>
        <div className="container-desk">
          <div className="desk">
            Citra Garden Bintaro merupakan kawasan hunian premium yang
            dikembangkan oleh Ciputra Group, menghadirkan konsep modern, hijau,
            dan nyaman untuk keluarga. Terletak di lokasi strategis dekat pusat
            kota Bintaro dan akses tol JORR, kawasan ini menawarkan kemudahan
            mobilitas ke berbagai area penting seperti CBD Jakarta, Pondok
            Indah, dan Bandara Soekarno-Hatta.
          </div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Clubhouse & Swimming Pool
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Children Playground
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;One Gate System
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Jogging Track
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Security 24 Hours
              </span>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="containerwa">
            <button
              className="buttonpenawaran"
              onClick={handleConsultationClick}>
              Learn More
            </button>
          </div>
        </div>
      </div>
      <div className="gambarabout">
        <img src={aboutimg} alt={aboutimg} />
      </div>
    </div>
  );
};

export default About;
